const translations = {
  title: 'Integraciones',
  name: 'Nombre',
  service: 'Servicio',
  createdAt: 'Creado el',
  updatedAt: 'Actualizado el',
  actions: 'Acciones',
  modalTitle: 'Crear nueva Integración',
  newIntegration: 'Nueva Integración',
  selectAccount: 'Seleccione una cuenta',
  newIntegrationWithService: 'Nueva Integración: {{service}}',
  tokenIntegrationDescription:
    '{{service}} no admite integración por redirección e inicio de sesión. Es necesario copiar el(los) token(s) de integración de la plataforma de {{service}} y pegarlo en el formulario a continuación:',
  select: 'Seleccionar',
  'widgets.segware.name': 'Integración con Segware',
  'widgets.segware.description': 'Crear integración con Segware',
  'widgets.twilio.name': 'Integración con Twilio',
  'widgets.twilio.description': 'Crear integración con Twilio',
  'widgets.chat_pro.name': 'Integración con ChatPro',
  'widgets.chat_pro.description': 'Crear integración con ChatPro',
  'widgets.slack.name': 'Integración con Slack',
  'widgets.slack.description': 'Crear integración con Slack',
  'widgets.google.name': 'Integración con Google Calendar',
  'widgets.google.description': 'Crear integración con Google Calendar',
  'widgets.d4sign.name': 'Integración con d4sign',
  'widgets.d4sign.description': 'Crear integración con D4sign',
  'segware.companyId': 'ID de Empresa*',
  'segware.bearerToken': 'Token Bearer*',
  'd4sign.tokenApi': 'Token Api*',
  'd4sign.cryptKey': 'Clave de Cifrado*',
  'twilio.accountSid': 'SID de Cuenta*',
  'twilio.authToken': 'Token de Autenticación*',
  'twilio.myTwilioPhone': 'Mi teléfono twilio*',
  'chat_pro.name': 'Nombre de la integración*',
  'chat_pro.instanceId': 'Instance ID*',
  'chat_pro.instanceToken': 'Instance Token*'
}

export default translations
